<div class="vc-details-side-item">
    <span class="h4-heading">
        {{ label }}
    </span>
    @if (value) {
        <vc-tooltip-text [text]="value" [tooltipMessage]="value"></vc-tooltip-text>
    }
    <ng-content></ng-content>
</div>
